module.exports = __webpack_public_path__ + "static/media/facerec.d40d2416.png";